module.exports = __webpack_public_path__ + "static/media/ca_logo.7d622666.png";